function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "o",
  d: "M56.7031 48.8281C56.7031 52.1719 56.125 55.1094 54.9688 57.6406C53.8125 60.1562 52.1562 62.0938 50 63.4531C47.8594 64.7969 45.3906 65.4688 42.5938 65.4688C39.8281 65.4688 37.3594 64.7969 35.1875 63.4531C33.0312 62.0938 31.3594 60.1641 30.1719 57.6641C29 55.1641 28.4062 52.2812 28.3906 49.0156V47.0938C28.3906 43.7656 28.9766 40.8281 30.1484 38.2812C31.3359 35.7344 33 33.7891 35.1406 32.4453C37.2969 31.0859 39.7656 30.4062 42.5469 30.4062C45.3281 30.4062 47.7891 31.0781 49.9297 32.4219C52.0859 33.75 53.75 35.6719 54.9219 38.1875C56.0938 40.6875 56.6875 43.6016 56.7031 46.9297V48.8281ZM50.7734 47.0469C50.7734 43.2656 50.0547 40.3672 48.6172 38.3516C47.1953 36.3359 45.1719 35.3281 42.5469 35.3281C39.9844 35.3281 37.9766 36.3359 36.5234 38.3516C35.0859 40.3516 34.3516 43.1875 34.3203 46.8594V48.8281C34.3203 52.5781 35.0469 55.4766 36.5 57.5234C37.9688 59.5703 40 60.5938 42.5938 60.5938C45.2188 60.5938 47.2344 59.5938 48.6406 57.5938C50.0625 55.5938 50.7734 52.6719 50.7734 48.8281V47.0469Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "square",
  d: "M3 3.2H81V93H3V3V3.2Z",
  stroke: "black",
  strokeWidth: 5,
  strokeLinejoin: "round"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    width: 84,
    height: 96,
    viewBox: "0 0 84 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8855dde1.svg";
export { ForwardRef as ReactComponent };